'helper'.trashAll('Location')
'helper'.trashAll('Inventory')
'helper'.trashAll('Evaluation')
'helper'.trashAll('POReceipt')
'helper'.trashAll('PO')
'helper'.trashAll('Mod')
'helper'.trashAll('Extension')
'helper'.trashAll('Template')
'helper'.trashAll('Facet')
'helper'.trashAll('Configuration')
'helper'.clearWCStockLevels()
'helper'.simulateBrowserRefresh()
'stocktend_inventory'.click()
  'Customize'.click()
    'Add Field'.click()
      'Get Value From'.enter('WC Product._purchase_note')
      'Caption'.enter('Purchase Note - Meta')
      'OK'.click()
    'Add Field'.click()
      'Get Value From'.enter('WC Product Attribute.granularity')
      'Display As'.enter('Number')
      'Caption'.enter('Granularity - Attribute')
      'OK'.click()
    'Back'.click()
  'Back'.click()
'stocktend_settings'.click()
  'Modify Profitori'.click()
    'Modify Built-in Specs'.click()
      'searcher'.enter('pr')
      'mainTable./products/.Modify'.click()
        'Javascript Code'.enter("'purchaseNote'.field({wcMeta: '_purchase_note'})")
        'Javascript Code'.addLine("'granularity'.field({wcAttribute: 'granularity'})")
        'OK'.click()
      'searcher'.enter('po')
      'mainTable./POMaint/.Modify'.click()
        'Javascript Code'.enter(  "'PO'.beforeSaving(async function() {")
        'Javascript Code'.addLine("  let lines = await 'POLine'.bringChildrenOf(this)")
        'Javascript Code'.addLine("  for ( var i = 0; i < lines.length; i++ ) {")
        'Javascript Code'.addLine("    let line = lines[i]")
        'Javascript Code'.addLine("    let product = await line.toProduct(); if ( ! product ) continue")
        'Javascript Code'.addLine("    product.purchaseNote = this.stage")
        'Javascript Code'.addLine("    product.granularity = line.unitCostIncTax")
        'Javascript Code'.addLine("  }")
        'Javascript Code'.addLine("})")
        'Javascript Code'.addLine("")
        'Javascript Code'.addLine("'stage'.options(['Entered', 'Sent to Supplier', 'Goods In Transit', 'Pre-Arrival', 'Goods Arrived', 'Complete'])")
        'OK'.click()
      'searcher'.enter('')
      'Back'.click()
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Add Line'.click()
      'Product'.enter('Cap (C01)')
      'Unit Price (Inc Tax)'.enter('100.00')
      'OK'.click()
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)')
      'Unit Price (Inc Tax)'.enter('200.00')
      'OK'.click()
    'Stage'.enter('Pre-Arrival')
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Cap (C01)/.Purchase Note - Meta'.shouldEqual('Pre-Arrival')
  'mainTable./Cap (C01)/.Granularity - Attribute'.shouldEqual('100.00')
  'mainTable./Hoodie (H01)/.Purchase Note - Meta'.shouldEqual('Pre-Arrival')
  'mainTable./Hoodie (H01)/.Granularity - Attribute'.shouldEqual('200.00')
  'mainTable./Bóónie (BOO100)/.Granularity - Attribute'.shouldEqual('1.11') // Manually set value - Make sure it's not clobbered
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Add Line'.click()
      'Product'.enter('Cap (C01)')
      'Unit Price (Inc Tax)'.enter('50.00')
      'OK'.click()
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)')
      'Unit Price (Inc Tax)'.enter('75.00')
      'OK'.click()
    'Stage'.enter('Goods Arrived')
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Cap (C01)/.Purchase Note - Meta'.shouldEqual('Goods Arrived')
  'mainTable./Cap (C01)/.Granularity - Attribute'.shouldEqual('50.00')
  'mainTable./Hoodie (H01)/.Purchase Note - Meta'.shouldEqual('Goods Arrived')
  'mainTable./Hoodie (H01)/.Granularity - Attribute'.shouldEqual('75.00')
  'Back'.click()
'helper'.trashAll('Location')
'helper'.trashAll('Stocktake')
'helper'.trashAll('Inventory')
'helper'.trashAll('PO')
'helper'.trashAll('Mod')
'helper'.trashAll('Extension')
'helper'.trashAll('Template')
'helper'.trashAll('Facet')
'helper'.trashAll('Configuration')
'helper'.clearWCStockLevels()
'helper'.simulateBrowserRefresh()
'stocktend_settings'.click()
  'Modify Profitori'.click()
    'Extension Specs'.click()
      'Extension Specs'.shouldBeCurrentPage()
      'Add'.click()
        'Add Extension Spec'.shouldBeCurrentPage()
        'Spec Name'.enter('POMaint')
        'OK'.click()
        'stFormRejection'.shouldContain('This name conflicts with a built-in spec')
        'Spec Name'.enter('AnimalList')
        'Status'.shouldEqual('Valid')
        'Javascript Code'.enter("'AnimalList'.list({expose: true})")
        'Javascript Code'.addLine("'Animals'.title()")
        'Javascript Code'.addLine("'Back'.action({act: 'cancel'})")
        'Javascript Code'.addLine("'Add'.action({act: 'add'})")
        'Javascript Code'.addLine("'Refresh'.action({act: 'refresh'})")
        'Javascript Code'.addLine("'Animal'.datatype()")
        'Javascript Code'.addLine("'animalName'.field({key: true})")
        'Javascript Code'.addLine("'Edit'.action({place: 'row', act: 'edit'})")
        'Javascript Code'.addLine("'Trash'.action({place: 'row', act: 'trash'})")
        'Javascript Code'.addLine("'AnimalMaint'.maintSpecname()")
        'Status'.shouldEqual('Valid')
        'OK'.click()
      'Add'.click()
        'Spec Name'.enter('AnimalList')
        'OK'.click()
        'stFormRejection'.shouldContain('This Extension already exists')
        'Spec Name'.enter('AnimalMaint')
        'Javascript Code'.enter("'AnimalMaint'.maint({panelStyle: 'titled'})")
        'Javascript Code'.addLine("'Add Animal'.title({when: 'adding'})")
        'Javascript Code'.addLine("'Edit Animal'.title({when: 'editing'})")
        'Javascript Code'.addLine("'Back'.action({act: 'cancel'})")
        'Javascript Code'.addLine("'OK'.action({act: 'ok'})")
        'Javascript Code'.addLine("'Save'.action({act: 'save'})")
        'Javascript Code'.addLine("'Animal'.datatype()")
        'Javascript Code'.addLine("'Species Summary'.panel()")
        'Javascript Code'.addLine("'animalName'.field()")
        'OK'.click()
      'Back'.click()
    'Back'.click()
  'helper'.trashAll("Animal")
  'Animals'.click()
    'Add'.click()
      'Animal Name'.enter('Monkey')
      'OK'.click()
    'mainTable.0.Animal Name'.shouldEqual('Monkey')
    'Add'.click()
      'Animal Name'.enter('Chimpanzee')
      'OK'.click()
    'mainTable.0.Animal Name'.shouldEqual('Chimpanzee')
    'mainTable./Chimpanzee/.Edit'.click()
      'Animal Name'.enter('Chimp')
      'OK'.click()
    'mainTable./Chimp/.Trash'.click()
    'mainTable./Chimp/.Really Trash?'.click()
    'mainTable'.shouldHaveCount(1)
    'Back'.click()
  'Modify Profitori'.click()
    'Modify Built-in Specs'.click()
      'Modify Built-in Specs'.shouldBeCurrentPage()
      'mainTable./EnterStocktakeCounts/.Modified'.shouldEqual('No')
      'mainTable./EnterStocktakeCounts/.Modify'.click()
        'Modify EnterStocktakeCounts'.shouldBeCurrentPage()
        'Status'.shouldEqual('Valid')
        'Javascript Code'.enter("'sku2'.field({caption: 'SKU 2'})")
        'Javascript Code'.addLine("")
        'Javascript Code'.addLine("'sku2'.calculate(async stocktakeLine => {")
        'Javascript Code'.addLine("  let product = await stocktakeLine.referee('product'); if ( ! product ) return ''")
        'Javascript Code'.addLine("  return product._sku")
        'Javascript Code'.addLine("})")
        'Javascript Code'.addLine("")
        'Javascript Code'.addLine("'product'.field({caption: 'Stock Item'})")
        'OK'.click()
      'mainTable./EnterStocktakeCounts/.Modified'.shouldEqual('Yes')
      'mainTable./EnterStocktakeCounts/.Modify'.click()
        'Javascript Code'.shouldContain("'sku2'.field(")
        'Back'.click()
      'mainTable./AdjustmentMaint/.Modified'.shouldEqual('No')
      'mainTable./AdjustmentMaint/.Modify'.click()
        'Back'.click()
        'Yes - Cancel my changes'.click('doc')
      'mainTable./AdjustmentMaint/.Modified'.shouldEqual('No')
      'Back'.click()
    'Back'.click()
  'Back'.click()
'stocktend_settings'.click()
  'Modify Profitori'.click()
    'Extension Specs'.click()
      'Extension Specs'.shouldBeCurrentPage()
      'Add'.click()
        'Add Extension Spec'.shouldBeCurrentPage()
        'Spec Name'.enter('MyClientList')
        'Javascript Code'.enter("'MyClientList'.list({expose: true})")
        'Javascript Code'.addLine("'My Clients'.title()")
        'Javascript Code'.addLine("'Back'.action({act: 'cancel'})")
        'Javascript Code'.addLine("'MyClient'.datatype()")
        'Javascript Code'.addLine("'clientNameName'.field({key: true})")
        'Status'.shouldEqual('Valid')
        'OK'.click()
      'Back'.click()
    'Back'.click()
  'My Clients'.click()
    'Back'.click()
  'Back'.click()
'Stocktake'.click()
  'Stocktakes'.shouldBeCurrentPage()
  'Start new Stocktake'.click()
    'Include Zero Quantities'.toggle()
    'OK'.click()
  'mainTable.0.Enter Counts'.click()
    'Lines./Hoodie with Logo (HL01)/.SKU 2'.shouldEqual('HL01')
    'Lines./Hoodie with Logo (HL01)/.Stock Item'.shouldEqual('Hoodie with Logo (HL01)')
    'Back'.click()
  'Back'.click()
'helper'.trashAll('Stocktake')
'helper'.trashAll('POReceipt')
'helper'.trashAll('PO')
'Stocktake'.click()
'Start new Stocktake'.click()
'Include Zero Quantities'.toggle()
'OK'.click()
'mainTable.<last>.Enter Counts'.click()
  'Stocktake Number'.shouldBeInView()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable.1.Product'.shouldEqual('Belt (#33)')
  'Back'.click()
'helper'.trashAll('Inventory')
'stocktend_inventory'.click()
  'mainTable.1.Product'.shouldEqual('Belt (#33)')
  'Back'.click()
'helper'.trashAll('Transaction')
'helper'.trashAll('Morsel')
'helper'.trashAll('Location')
'helper'.clearWCStockLevels()
'helper'.flushCache()
'helper'.simulateBrowserRefresh()
'Locations'.click()
  'Add'.click()
    'Name'.enter('WH01')
    'OK'.click()
  'Back'.click()
'stocktend_settings'.click()
  'Short Date Format'.enter('dd/mm/yyyy')
  'OK'.click()
'Inventory'.click()
  'Inventory'.shouldBeCurrentPage()
  'mainTable./Belt (#33)/.Quantity On Hand'.shouldEqual('0')
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
  'Purchase Order Number'.enter('PO00002')
    'Add Line'.click()
      'Product'.chooseOption('Shórts - Blue (SB01)')
      'Quantity'.enter('10')
      'Add another line'.click()
      'Product'.chooseOption('Shórts - Red (SR01)')
      'Quantity'.enter('2')
      'Add another line'.click()
      'Product'.chooseOption('Hoodie (H01)')
      'Quantity'.enter('1')
      'Add another line'.click()
      'Product'.chooseOption('Belt (#33)')
      'Quantity'.enter('1')
      'OK'.click()
    'OK'.click()
  'Add'.click()
  'Purchase Order Number'.enter('PO00003')
    'Location'.chooseOption('WH01')
    'Add Line'.click()
      'Product'.chooseOption('Cap (C01)')
      'Quantity'.enter('11')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'Receive Purchases'.click()
  'mainTable./PO00002/.Enter Receipt'.click()
    'Lines'.shouldHaveCount(4)
    'OK'.click()
  'mainTable./PO00003/.Enter Receipt'.click()
    'Lines'.shouldHaveCount(1)
    'OK'.click()
  'Back'.click()
'Inventory'.click()
  'mainTable./Belt (#33)/.Quantity On Hand'.shouldEqual('1')
  'searcher'.enter('s')
  'mainTable./Shórts - Blue (SB01)/.Quantity On Hand'.shouldEqual('10')
  'mainTable./Shórts - Red (SR01)/.Quantity On Hand'.shouldEqual('2')
  'searcher'.enter('h')
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('1')
  'mainTable./Hoodie with Logo (HL01)/.Adjust Qty'.click()
    'Location'.chooseOption('WH01')
    'Quantity'.enter('1')
    'OK'.click()
  'Stocktake'.click()
    'Stocktakes'.shouldBeCurrentPage()
    'mainTable'.forEach('true', {lastToFirst: true})
      'Trash'.click()
      'Really Trash?'.click()
      'mainTable'.endForEach()
    'Start new Stocktake'.click()
      'Location'.chooseOption('WH01')
      'OK'.click()
    'Stocktakes'.shouldBeCurrentPage()
    'mainTable.0.Enter Counts'.click()
      'Enter Stocktake Counts'.shouldBeCurrentPage()
      'Location'.shouldEqual('WH01')
      'Location'.shouldBeReadOnly()
      'Lines./Hoodie with Logo (HL01)/.Counted Quantity'.enter('153')
      'Lines./Cap (C01)/.Counted Quantity'.enter('11')
      'OK'.click()
    'Stocktakes'.shouldBeCurrentPage()
    'mainTable.0.Edit'.click()
      'Location'.shouldEqual('WH01')
      'Location'.chooseOption('General')
      'messageDialog'.shouldExist('doc')
      'messageDialogText'.shouldEqual("This stocktake has counted quantities - cannot alter Location", 'doc')
      'messageDialogOK'.click('doc')
      'Include Zero Quantities'.toggle()
      'messageDialog'.shouldExist('doc')
      'messageDialogText'.shouldEqual("This stocktake has counted quantities - cannot alter Include Zero Quantities", 'doc')
      'messageDialogOK'.click('doc')
      'Back'.click()
    'mainTable.0.Enter Counts'.click()
      'Finalise'.click()
      'messageDialog'.shouldExist('doc')
      'messageDialogText'.shouldEqual("The Stocktake has been finalised", 'doc')
      'messageDialogOK'.click('doc')
      'Back'.click()
    'Inventory'.click()
      'mainTable./Hoodie with Logo (HL01)/.Quantity On Hand'.shouldEqual('153')
      'mainTable./Hoodie with Logo (HL01)/.Inventory by Location'.click()
        'mainTable./WH01/.On Hand'.shouldEqual('153')
        'Back'.click()
      'mainTable./Hoodie with Logo (HL01)/.Adjust Qty'.click()
        'Location'.enter('WH01')
        'Quantity'.enter('-153')
        'OK'.click()
      'Back'.click()
    'Stocktakes'.shouldBeCurrentPage()
    'Start new Stocktake'.click()
      'Stocktake'.shouldBeCurrentPage()
      'Stocktake Date'.shouldEqualExpression('global.todayLocal()')
      'Stocktake Date'.enterExpression('global.todayLocal().incDays(7)')
      'Location'.shouldEqual('General')
      'Include Zero Quantities'.shouldEqual('No')
      'Lines./Cap (C01)/'.shouldntExist()
      'Include Zero Quantities'.toggle()
      'Include Zero Quantities'.shouldEqual('Yes')
      'Lines'.scrollToEnd()
      'Lines.0.Product'.shouldEqual('Belt (#33)')
      'Lines.<last>.Product'.shouldEqual('Vneck Tshirt (V01)')
      'Lines.<columnHeadings>.Product'.shouldIndicateSortAscending()
      'Lines.<columnHeadings>.Product'.click()
      'Lines.<columnHeadings>.Product'.shouldIndicateSortDescending()
      'Lines.0.Product'.shouldEqual('Vneck Tshirt (V01)')
      'Lines.<last>.Product'.shouldEqual('Belt (#33)')
      'Lines.<columnHeadings>.Product'.click()
      'Lines.<columnHeadings>.Product'.shouldIndicateSortAscending()
      'Lines.0.Product'.shouldEqual('Belt (#33)')
      'Lines.<last>.Product'.shouldEqual('Vneck Tshirt (V01)')
      'Lines.<columnHeadings>.System Quantity'.shouldntIndicateSort()
      'Lines.<columnHeadings>.System Quantity'.click()
      'Lines.<columnHeadings>.System Quantity'.shouldIndicateSortAscending()
      'Lines.<columnHeadings>.Product'.shouldntIndicateSort()
      'Lines.<last>.Product'.shouldEqual('Shórts - Blue (SB01)')
      'Lines.<columnHeadings>.System Quantity'.click()
      'Lines.<columnHeadings>.System Quantity'.shouldIndicateSortDescending()
      'Lines.0.Product'.shouldEqual('Shórts - Blue (SB01)')
      'Lines.1.Product'.shouldEqual('Shórts - Red (SR01)')
      'Lines./Cap (C01)/'.shouldExist()
      'Include Zero Quantities'.toggle()
      'Lines./Cap (C01)/'.shouldntExist()
      'Lines.<columnHeadings>.System Quantity'.shouldIndicateSortDescending()
      'Status'.shouldEqual('Unfinalised')
      'Status'.shouldBeReadOnly()
      'Lines./Shórts - Blue (SB01)/.System Quantity'.shouldEqual('10')
      'Lines./Shórts - Red (SR01)/.System Quantity'.shouldEqual('2')
      'Lines./Hoodie (H01)/.System Quantity'.shouldEqual('1')
      'Save'.click()
      'Stocktake'.click()
        'browser'.back()
      'Lines.<columnHeadings>.System Quantity'.shouldIndicateSortDescending()
      'Location'.chooseOption('WH01')
      'Lines.0.Product'.shouldEqual('Cap (C01)')
      'Lines./Cap (C01)/.System Quantity'.shouldEqual('11')
      'Lines'.shouldHaveCount(1)
      'Location'.chooseOption('General')
      'Lines./Cap (C01)/'.shouldntExist()
      'Lines./Shórts - Blue (SB01)/.System Quantity'.shouldEqual('10')
      'Lines./Shórts - Red (SR01)/.System Quantity'.shouldEqual('2')
      'Lines./Hoodie (H01)/.System Quantity'.shouldEqual('1')
      'OK'.click()
    'mainTable.0.Stocktake Number'.shouldMatch('ST[0-9]*')
    'mainTable.0.Edit'.click()
      'Lines./Shórts - Blue (SB01)/.System Quantity'.shouldEqual('10')
      'Lines./Belt (#33)/.Exclude'.click()
      'Lines./Belt (#33)/.Really Exclude?'.click()
      'Lines./Hoodie (H01)/.Exclude'.click()
      'Lines./Hoodie (H01)/.Really Exclude?'.click()
      'OK'.click()
    'Stocktakes'.shouldBeCurrentPage()
    'mainTable.0.Enter Counts'.click()
      'Enter Stocktake Counts'.shouldBeCurrentPage()
      'Status'.shouldEqual('Unfinalised')
      'Status'.shouldBeReadOnly()
      'Lines./Shórts - Blue (SB01)/.Counted Quantity'.shouldEqual('')
      'Lines./Shórts - Red (SR01)/.Counted Quantity'.shouldEqual('')
      'OK'.click()
    'Stocktakes'.shouldBeCurrentPage()
    'mainTable.0.Enter Counts'.click()
      'Enter Stocktake Counts'.shouldBeCurrentPage()
      'Location'.shouldEqual('General')
      'Location'.shouldBeReadOnly()
      'Lines./Shórts - Blue (SB01)/.Counted Quantity'.enter('9')
      'Finalise'.click()
      'messageDialog'.shouldExist('doc')
      'messageDialogText'.shouldEqual("Please enter a quantity for all products before finalising", 'doc')
      'messageDialogOK'.click('doc')
      'Status'.shouldEqual('Unfinalised')
      'messageDialog'.shouldntExist('doc')
      'OK'.click()
    'Stocktakes'.shouldBeCurrentPage()
      'mainTable.0.Enter Counts'.click()
      'Lines./Shórts - Blue (SB01)/.Counted Quantity'.shouldEqual('9')
      'Lines./Shórts - Red (SR01)/.Counted Quantity'.shouldEqual('')
      'Lines./Shórts - Red (SR01)/.Counted Quantity'.enter('0')
      'OK'.click()
    'Stocktakes'.shouldBeCurrentPage()
    'mainTable.0.Enter Counts'.click()
      'Lines./Shórts - Blue (SB01)/.Counted Quantity'.shouldEqual('9')
      'Lines./Shórts - Red (SR01)/.Counted Quantity'.shouldEqual('0')
      'Lines./Shórts - Red (SR01)/.Counted Quantity'.enter('')
      'OK'.click()
    'mainTable.0.Status'.shouldEqual('Unfinalised')
    'mainTable.0.Enter Counts'.click()
      'Lines./Shórts - Blue (SB01)/.Counted Quantity'.shouldEqual('9')
      'Lines./Shórts - Red (SR01)/.Counted Quantity'.shouldEqual('')
      'Lines./Shórts - Red (SR01)/.Counted Quantity'.enter('0')
      'Finalise'.click()
      'messageDialog'.shouldExist('doc')
      'messageDialogText'.shouldEqual("The Stocktake has been finalised", 'doc')
      'messageDialogOK'.click('doc')
      'Finalise'.click()
      'messageDialog'.shouldExist('doc')
      'messageDialogText'.shouldEqual("This Stocktake has already been finalised previously", 'doc')
      'messageDialogOK'.click('doc')
      'messageDialog'.shouldntExist('doc')
      'Status'.shouldEqual('Finalised')
      'Back'.click()
    'Stocktakes'.shouldBeCurrentPage()
    'mainTable.0.Status'.shouldEqual('Finalised')
    'mainTable.0.Edit'.click()
      'Status'.shouldEqual('Finalised')
      'Stocktake Date'.shouldBeReadOnly()
      'Stocktake Number'.shouldBeReadOnly()
      'Lines.0.Exclude'.click()
      'messageDialogText'.shouldEqual("This Stocktake has been finalised and cannot be altered", 'doc')
      'messageDialogOK'.click('doc')
      'Save'.click()
      'messageDialogText'.shouldEqual("This Stocktake has been finalised and cannot be altered", 'doc')
      'messageDialogOK'.click('doc')
      'Back'.click()
    'Stocktakes'.shouldBeCurrentPage()
    'mainTable.0.Enter Counts'.click()
      'Status'.shouldEqual('Finalised')
      'Lines./Shórts - Blue (SB01)/.Counted Quantity'.shouldBeReadOnly()
      'Lines./Shórts - Blue (SB01)/.Counted Quantity'.shouldEqual('9')
    'Back'.click()
  'Stocktakes'.shouldBeCurrentPage()
  'Back'.click()
'Inventory'.click()
  'searcher'.enter('s')
  'mainTable./Shórts - Blue (SB01)/.Quantity On Hand'.shouldEqual('9')
  'mainTable./Shórts - Red (SR01)/.Quantity On Hand'.shouldEqual('0')
  'mainTable./Shórts - Red (SR01)/.On Purchase Orders'.shouldEqual('0')
  'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('0')
  'searcher'.enter('h')
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('1')
  'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('0')
  'searcher'.enter('c')
  'mainTable./Cap (C01)/.Adjust Value'.click()
    'Avg Unit Cost'.enter('20.00')
    'OK'.click()
  'mainTable./Cap (C01)/.Inventory by Location'.click()
    'mainTable'.shouldHaveCount(3) // General, WH01, Total
    'Back'.click()
  'mainTable./Cap (C01)/.Include In Stocktake'.shouldntExist()
  'searcher'.enter('')
  'Generate Stocktake'.click()
    'mainTable./Cap (C01)/.Include In Stocktake'.shouldBeUnticked()
    'Select None'.shouldntExist()
    'Select All'.click()
    'Select All'.shouldntExist()
    'mainTable./Cap (C01)/.Include In Stocktake'.shouldBeTicked()
    'mainTable./Hoodie (H01)/.Include In Stocktake'.shouldBeTicked()
    'Select None'.click()
    'Select None'.shouldntExist()
    'Select All'.shouldExist()
    'mainTable./Cap (C01)/.Include In Stocktake'.shouldBeUnticked()
    'mainTable./Hoodie (H01)/.Include In Stocktake'.shouldBeUnticked()
    'mainTable./Cap (C01)/.Include In Stocktake'.toggleTick()
    'mainTable./Hoodie (H01)/.Include In Stocktake'.toggleTick()
    'mainTable./Cap (C01)/.Include In Stocktake'.shouldBeTicked()
    'mainTable./Hoodie (H01)/.Include In Stocktake'.shouldBeTicked()
    'Create Stocktake'.click()
      'Edit Stocktake'.shouldBeCurrentPage()
      'Location'.shouldEqual('General')
      'Lines'.shouldHaveCount(2)
      'Lines.0.Product'.shouldEqual('Cap (C01)')
      'Lines.0.System Quantity'.shouldEqual('11')
      'Back'.click()
    'Inventory'.shouldBeCurrentPage()
    'Create Stocktake'.shouldExist()
    'Back'.click()
  'Inventory'.shouldBeCurrentPage()
  'Create Stocktake'.shouldntExist()
  'Back'.click()
